import {
  DownloadInfoType,
  OrgType,
} from '@/types';
import {
  $get,
  $request,
} from '@/utils/request';

import servers from '../servers';

/**
 * @description: 获取权限内的组织树
 */
export const getOrgTreeRequest = () => $get<ResponseData<OrgType[]>>(`${servers.base}/api/v1/user/authOrgTree`);

/**
 * @description: 获取所有枚举值
 * YApi： https://apidock.longhu.net/project/7143/interface/api/891150
 */
export const getEnumByCodeRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.backend}/api/v1/common/dict/bizList`,
  method: 'get',
  params,
});

/**
 * @description: 获取全量枚举值
 */
export const getBizMapList = (params = {}) => $request<ResponseData>({
  url: `${servers.backend}/api/v1/common/dict/bizMapList`,
  method: 'get',
  params,
});

/**
 * @description: 下载中心 -- 获取下载内容列表
 */
export const getDownloadsRequest = (params = {}) => $request<ResponseData<DownloadInfoType[]>>({
  url: `${servers.base}/api/v1/async/export/list`,
  method: 'get',
  params,
});

/**
 * @description: 下载中心 -- 下载操作
 */
export const downloadRequestUrl = `${servers.base}/api/v1/async/export/download`;

/**
 * @description: 异步导出 -- 通用导出接口
 */
export const exportRequestUrl = `${servers.backend}/api/v1/async/export/do`;

/**
 * @description: 异步导出 -- 后端返回指定下载文件地址下载文件
 */
export const downloadByUrlRequest = (url: string, data: TypeObject, method = 'get') => {
  const axiosParams: TypeObject = {
    url,
    method,
  };

  if (method === 'get') {
    axiosParams.params = data;
  } else {
    axiosParams.data = data;
  }
  return $request(axiosParams);
};

/**
 * @description: 后端返回返回的文档流下载文件
 * @param {any} data 请求参数
 * @return {*}
 */
export const downloadByStreamRequest = (url: string, data: TypeObject, method = 'get') => {
  const axiosParams: TypeObject = {};
  if (method === 'get') {
    axiosParams.params = data;
  } else {
    axiosParams.data = data;
  }
  return $request({
    url,
    method,
    headers: {
      'Content-Type': method === 'get' ? 'application/x-www-form-urlencoded' : 'application/json;charset=utf-8',
    },
    responseType: 'blob',
    ...axiosParams,
  });
};

/**
 * @description: 获取所有的查询参数枚举集合
 * @param {*} params 传递参数只查询对应参数的内容，不传递默认查询全部
 * @return {*}
 */
export const getMapRequest = (params = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/common/dict/front`,
  method: 'get',
  params,
});

/**
 * @description: 导入
 */
export const uploadByUrlRequest = (url: string, data: TypeObject, method = 'post') => {
  const axiosParams: TypeObject = {
    url,
    method,
  };

  if (method === 'get') {
    axiosParams.params = data;
  } else {
    axiosParams.data = data;
  }
  return $request(axiosParams);
};

/**
 * @description: 通用的下载模板的接口
 */
export const downloadTemplateRequestUrl = `${servers.backend}/api/v1/template/download`;

/**
 * @description: 获取所有的查询参数枚举集合
 * @param {*} params 传递参数只查询对应参数的内容，不传递默认查询全部
 * @return {*}
 */
export const getIconByDeviceCode = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/icon/config/alarm/list`,
  method: 'post',
  data,
});

/**
 * @description: 根据空间在线oneId获取空间编码
 * @param {*} oneIds
 * @return {*}
 */
export const getCodeByOneIdsRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/space/spaceInfo/getCodeByOneIds`,
  method: 'post',
  data,
});

/**
 * @description: 根据空间编码获取空间在线的oneId
 * @param {*} oneIds
 * @return {*}
 */
export const getOneIdsBySpaceCodesRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/space/spaceInfo/getOneIdsBySpaceCodes`,
  method: 'post',
  data,
});

/**
 * @description: 根据设备编码获取空间在线的oneId
 * @param {*} oneIds
 * @return {*}
 */
export const getEquipSpaceCodeByOneIdsRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/space/spaceInfo/getEquipSpaceCodeByOneIds`,
  method: 'post',
  data,
});
/**
 * @description: 根据设备编码获取空间在线的oneId
 * @param {*} oneIds
 * @return {*}
 */
export const getEquipOneIdsBySpaceCodesRequest = (data = {}) => $request<ResponseData>({
  url: `${servers.base}/api/v1/space/spaceInfo/getEquipOneIdsBySpaceCodes`,
  method: 'post',
  data,
});
